import {
  Container,
  Title,
  Text,
  Group,
  Image,
  createStyles,
} from '@mantine/core';
const useStyle = createStyles((theme) => ({}));
const NameHouseCompo = (props) => {
  const { classes } = useStyle();
  const { unitFacilities } = props;
  return (
    <Container className={classes.container} mt={40} mb={40}>
      <Title
        size={24}
        mb={10}
        style={{ fontFamily: 'Nunito Sans, sans-serif', fontWeight: 700 }}
      >
        {props.type}
      </Title>
      <Text
        size={20}
        mb={10}
        style={{ fontFamily: 'Nunito Sans, sans-serif', fontWeight: 400 }}
      >
        {props.name}
      </Text>
      <Group align="flex-end">
        <Text color="#F56600" mr={40} size={18} weight={400}>
          {props.price}
        </Text>
        <Group spacing="xs" pb={3}>
          {unitFacilities.bathroom && (
            <Group align="flex-start" spacing="xs">
              <Image src={props.icon1} width={15} />
              <Text size="xs">{unitFacilities.bathroom}</Text>
            </Group>
          )}
          <Group align="center" spacing="xs">
            <Image src={props.icon2} width={15} />
            <Text size="xs">{props.detail2}</Text>
          </Group>
          <Group align="center" spacing="xs">
            <Image src={props.icon3} width={15} />
            <Text size="xs">{props.detail3}</Text>
          </Group>
          <Group align="center" spacing="xs">
            <Image src={props.icon4} width={15} />
            <Text size="xs">{props.detail4}</Text>
          </Group>
        </Group>
      </Group>
    </Container>
  );
};
export default NameHouseCompo;
